import { action, makeObservable, observable } from 'mobx';
import * as utils from '../../helpers/utils';

class ContactType {
  _id;

  TypeId;

  @observable TypeName;

  constructor(incObject) {
    makeObservable(this);

    this._id = incObject._id ? incObject._id : utils.generateGuid();
    this.TypeId = incObject.TypeId || null;
    this.TypeName = incObject.TypeName || null;
  }

  /* eslint-disable */
  @action static UpdateObject(incObject, oldObject) {
    oldObject.TypeId = incObject.TypeId;
    oldObject.TypeName = incObject.TypeName;
    return oldObject;
  }
  /* eslint-enable */
}

export default ContactType;
